// extracted by mini-css-extract-plugin
export var icon = "_3m-3";
export var subtitle = "_3m-2";
export var title = "_3m-1";
export var value = "_3m-0";